import { useSearchAiPluginStore } from 'store/searchAiPluginStore';

interface Props {
    colorField: 'searchButtonColor' | 'themeColor';
}

const CustomColorPicker = ({ colorField }: Props) => {
    const { setCustomization } = useSearchAiPluginStore();
    const colors = ['#000000', '#FF4B4B', '#FF9F3E', '#FFD600', '#4CD964', '#4B6BFF', '#A44DFF'];

    return (
        <div className="flex gap-4">
            {colors.map((color) => (
                <button
                    key={color}
                    onClick={() => setCustomization(colorField, color)}
                    className={`
              w-10 h-10 rounded-full
              transition-all duration-200
              hover:scale-110
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              }
            `}
                    style={{ backgroundColor: color }}
                    aria-label={`Select color ${color}`}
                />
            ))}
        </div>
    );
};

export default CustomColorPicker;
